import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Paper,
  Toolbar,
  Typography,
  Box,
  PaginationItem,
} from "@mui/material";
import { api, get, put } from "../../../utils/api";
import { styled } from "@mui/material/styles";
import PaginationBox from "../../../Components/Masters/Pagination";
import DeleteDialog from "../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../Components/Masters/MenuActions";
import TableContent from "../../../Components/Masters/TableContent";
import FilterDrawer from "../../../Components/Masters/FilterDrawer";
import TopMenu from "../../../Components/Masters/TopMenu";
import MessagePopup from "../../../Components/Masters/MessagePopup";
import TableHeading from "../../../Components/Masters/TableHeading";
import MenuIcon from "../../../Components/Masters/MenuIcon";
import { companyId } from "../../../utils/companyId";
import AddFireExtingulsher from "./AddFireExtingulsher";
import ViewFireExtingulsher from "./ViewFireExtingulsher";
import DateRangePickerComponent from "../../Masters/Roles and Permissions/Filters/Date";
import MultiSelect from "../../Masters/Roles and Permissions/Filters/MultiSelect";
import Range from "../../Masters/Roles and Permissions/Filters/Range";
import Cards from "../../../Components/Common/Cards";
import MonthYearFilter from "../../Masters/Roles and Permissions/Filters/MonthYearFilter";
import dayjs from "dayjs";
import { getMonthName } from "../../../utils/getMonthName";
import BulkUploadModal from "../../../Components/Common/BulkUploadModal";
import TopMenuUpload from "../../../Components/Masters/TopMenuUpload";
import {
  formatNumberCommaSeparated,
  truncateNumber,
} from "../../../utils/common";
import NoDataFound from "../../../Components/Masters/NoDataFound";
import BulkUpload from "../StationaryCombustion.js/NaturalGas/BulkUpload";
import FugitiveBulkUpload from "./FugitiveBulkUpload";
import { useUser } from "../../../context/AuthContext";
import DeleteAlertDialog from "../../../Components/Masters/DeleteAlertDialog";

const typeOfSubstanceList = [
  "ABC (Ammonium Phosphate : Sulphate 40:60)",
  "ABC (Ammonium Phosphate : Sulphate 60:40)",
  "ABC (Ammonium Phosphate : Sulphate 90:10)",
  "CO2",
  "Clean Agent Fire Extinguishers: HFC-227ea (FM-200)",
  "Clean Agent Fire Extinguishers: HFC-236fa (FE-36)",
  "Clean Agent Fire Extinguishers: Novec 1230",
  "Clean Agent Fire Extinguishers: FE-13",
];

const FireExtingulsher = () => {
  const { user } = useUser();
  const [selectedPeriod, setSelectedPeriod] = React.useState("July");
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [cardData, setCardData] = useState({});
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    "Industrial Process": false,
    "Equipment Type": false,
    "Industrial Equipment": false,
    "Fuel Type": false,
    "Quantity Consumed": false,
    "Hours Used": false,
  });
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({});
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    Date: false,
    "Industrial Process": false,
    "Equipment Type": false,
    "Industrial Equipment": false,
    "Fule Type": false,
    "Quantity of Fuel Consumed": false,
    "Hours Used": false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    fugitiveEmissionSource: [],
    typeOfSubstance: [],
    quantityReleased: [],
  });
  const [filterValues, setFilterValue] = useState([]);
  const [quantityRelsed, setQuantityRange] = useState({ min: "", max: "" });
  const [hoursRange, setHoursRange] = useState({ min: "", max: "" });
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [bulkUploadTable, setBulkUploadTable] = useState(true);
  const [excelData, setExcelData] = useState(null);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const [matchData, setMatchData] = useState([]);

  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    typeOfSubstance: [],
    quantityRelsed: { min: "", max: "" },
    startMonth: null,
    endMonth: null,
  });

  const fetchExcelData = async () => {
    let arr = typeOfSubstanceList.map((item, idx) => {
      return {
        "S No.": idx + 1,
        "Month (in 01/25 or Jan-25)": "",
        "Type Of Substance": item,
        "Quantity Released": "",
        "Remark (optional)": "",
        // Document: "",
      };
    });
    setExcelData(arr);
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };

  const [filter, setFilters] = useState({});
  //   const[minRange,setMinRange]=useState({
  //     quantityConsumed:{min:"",max:""},
  //     hoursUsed:{min:"",max:""}
  //   })

  const filters = [
    "Date",
    "Consumption Month",
    // "Fugitive EmissionSource",
    "Type Of Substance",
    "Quantity Released",
  ];

  const inputData = [
    // {
    //   fieldName: "fugitiveEmissionSource",
    //   title: "Emission source",
    //   placeholder: "Select equipment type",
    //   type: "select",
    //    options: ["Fire extinguisher"],
    //   required: true,
    // },
    {
      fieldName: "consumptionPeriod",
      title: "Consumption Month",
      required: true,
      type: "date",
    },
    {
      fieldName: "typeOfSubstance",
      title: "Type of Substance",
      placeholder: "Type of Substance",
      type: "select",
      options: [
        "ABC (Ammonium Phosphate : Sulphate 40:60)",
        "ABC (Ammonium Phosphate : Sulphate 60:40)",
        "ABC (Ammonium Phosphate : Sulphate 90:10)",
        "CO2",
        "Clean Agent Fire Extinguishers: HFC-227ea (FM-200)",
        "Clean Agent Fire Extinguishers: HFC-236fa (FE-36)",
        "Clean Agent Fire Extinguishers: Novec 1230",
        "Clean Agent Fire Extinguishers: FE-13",
      ],
      //   url: `${api}/master/scope1/getAllMachinery`,
      required: true,
    },
    {
      fieldName: "quantityReleased",
      title: "Quantity Released",
      placeholder: "Quantity Released",
      type: "number",
      //   url: `${api}/master/scope1/getAllMachinery`,
      required: true,
    },
    // {
    //   fieldName: "typeOfEntry",
    //   title: "Type of Entry",
    //   placeholder: "Type here",
    //   type: "select",
    //   options: ["Cumulative", "Individual"],
    //   required: true,
    // },
    // {
    //   fieldName: "uniqueIdOfEquipment",
    //   title: "Unique ID of Entry",
    //   placeholder: "Select industrial equipment",
    //   type: "number",
    //   url: `${api}/master/scope1/getAllMachinery`,
    //   // url: `${api}/master/getAllIndustrialEquipment`,
    //   condition: true,
    // },
    // {
    //   fieldName: "fuelType",
    //   title: "Fule Type",
    //   placeholder: "Auto filed",
    //   type: "text",
    //   required: true,
    // },
    // {
    //   fieldName: "quantityOfFuelConsumed",
    //   title: "Quantity of Fuel Consumed",
    //   placeholder: "Litre",
    //   type: "number",
    //   condition: true,
    // },
    // {
    //   fieldName: "hoursUsed",
    //   title: "Hours Used",
    //   placeholder: "Enter hours",
    //   type: "number",
    //   condition: true,
    // },
    {
      fieldName: "remarks",
      title: "Remark (optional)",
      placeholder: "Additional remarks",
      type: "text",
    },
      {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ];

  let bannerData = [
    {
      title: "Most Released Substance",
      description: cardData.Substance,
    },
    {
      title: "Total Quantity Released",
      description:
        cardData.QuantityRelesed === ""
          ? "N/A"
          : truncateNumber(cardData.QuantityRelesed),
      unit: "kg",
      filter: "option",
      filterTitle: "Tap to Select",
      key: "typeOfSubstance",
      filterValues: filterValues,
      defaultValue:
        cardData?.quanityName === undefined
          ? "ABC (Ammonium Phosphate : Sulphate 40:60)"
          : cardData?.quanityName,
    },
    // {
    //   title: "Total Distance Travelled",
    //   description: "1000 Km",
    //   filter: "option",
    //   filterTitle: "Shipment Category",
    //   filterValues: ["Liquid Shipment", "Dry Shipment"],
    // },
    {
      title: "Fugitive Released",
      description:
        cardData.Monthly === undefined ||
        cardData.Monthly === "" ||
        cardData.Monthly === false
          ? "N/A"
          : formatNumberCommaSeparated(cardData?.Monthly),
      unit: "kg",
      filter: "date",
    },
  ];

  console.log("carddata", bannerData);

  const FetchSequenceData = async () => {
    await get(`/scope1/fireEmission/filter`)
      .then((response) => {
        setFilterValue(response.data.data.typeOfSubstance);
        console.log(response.data.data.typeOfSubstance, "forfilter");
      })
      .catch((err) => console.log(err));
  };

  const fetchCardData = async (
    year,
    month,
    quantity = cardData?.quanityName
  ) => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    try {
      const response = await get(
        `/scope1/fireEmission/fireExtinguisherCardData`,
        {
          params: {
            // year,
            // month,
            typeOfSubstance: quantity,
            year: selectedYear ? selectedYear : currentYear,
            month: selectedMonth ? selectedMonth : currentMonth + 1,
          },
        }
      );
      if (response) {
        console.log(response.data.data, "cardData");
        setCardData({
          ...cardData,
          Substance: response.data.data.recent.map(
            (item) => item.typeOfSubstance
          ),
          Monthly:
            response.data.data.monthly.length > 0 &&
            response.data.data.monthly.map((item) => item.quntity),
          QuantityRelesed: response.data.data.total?.map(
            (item) => item.quntity
          ),
          quanityName: quantity,
        });
      }
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  useEffect(() => {
    if (filterValues.length > 0) {
      fetchCardData(selectedYear, selectedMonth, filterValues[0]);
    }
  }, [filterValues]);

  useEffect(() => {
    if (filterValues.length > 0) {
      fetchCardData(selectedYear, selectedMonth);
    }
  }, [selectedMonth, selectedYear]);

  useEffect(() => {
    // const year = selectedDate.year();
    // const month = selectedDate.month() + 1; // Month is 0-indexed in dayjs
    FetchSequenceData();
  }, [selectedDate]);

  const fetchUniqueValues = async () => {
    try {
      const response = await get(
        `/scope1/fireEmission/getAllFireExtinguishers`
      );
      const data = response.data.data;
      console.log(data, "FETCHUNQUIEVALUE");

      const uniquequantityReleased = [
        ...new Set(
          data.map((el) => el.quantityReleased).filter(Boolean) // Filter out undefined values
        ),
      ];

      console.log(uniquequantityReleased);

      const uniquetypeOfSubstance = [
        ...new Set(
          data.map((el) => el.typeOfSubstance).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniquefugitiveEmissionSource = [
        ...new Set(
          data.map((el) => el.fugitiveEmissionSource).filter(Boolean) // Filter out undefined values
        ),
      ];

      return {
        quantityReleased: uniquequantityReleased,
        typeOfSubstance: uniquetypeOfSubstance,
        // fuelType: uniqueIndustrialEquipment,
        fugitiveEmissionSource: uniquefugitiveEmissionSource,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  // fetching Vehicle data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
        company: companyId,
        createdBy: companyId,
      }).toString();
      const response = await get(
        `/scope1/fireEmission/getAllFireExtinguishers?${queryParams}`
      );
      setData(response.data.data); // Update the user list
      console.log(response.data.data);
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
      FetchSequenceData();
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig]);

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
    console.log(element);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedData(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleDeleteAggree = async () => {
    // console.log("indexhandleDeleteAggree", vehicle, vehicle._id);
    try {
      console.log(element._id);
      const res = await put(
        `/scope1/fireEmission/deleteFireExtinguisher?Id=${element._id}`
      );
      setDeleteDialog(false);
      setsnackOpen({
        open: true,
        message: res.data.message,
        severity: "success",
      });
      fetchData();
    } catch (err) {
      console.log(err);
      setsnackOpen({
        open: true,
        message: err.data?.response.message ?? "network Error",
        severity: "error",
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    startMonth: tempFilter?.startMonth
      ? tempFilter?.startMonth.format("YYYY-MM")
      : "",
    endMonth: tempFilter?.endMonth
      ? tempFilter?.endMonth.format("YYYY-MM")
      : "",
    typeOfSubstance: tempFilter?.typeOfSubstance || "",
    minQuantityReleased: tempFilter?.quantityRelsed.min || "",
    maxQuantityReleased: tempFilter?.quantityRelsed.max || "",
    minHours: tempFilter?.hoursRange?.min || "",
    maxHours: tempFilter?.hoursRange?.max || "",
  };

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = {
      Date: false,
      //   "Fugitive EmissionSource": false,
      "Type Of Substance": false,
      "Quantity Released": false,
    };

    if (selectedFilter === "Date") {
      const today = new Date(); // Get the current date
      if (!tempFilter?.startDate && !tempFilter?.endDate) {
        newErrors.Date = "Please select start date & end date";
        isValid = false;
      }

      if (tempFilter?.startDate && tempFilter?.startDate > today) {
        newErrors.Date = "Start date cannot be in the future";
        isValid = false;
      }

      if (tempFilter?.endDate && tempFilter?.endDate > today) {
        newErrors.Date = "End date cannot be in the future";
        isValid = false;
      }

      // Ensure that the tempFilter?.startDate is less than or equal to the endDate
      if (
        tempFilter?.startDate &&
        tempFilter?.endDate &&
        tempFilter?.startDate > tempFilter?.endDate
      ) {
        newErrors.Date = "End date must be greater than Start date";
        isValid = false;
      }
    }
    // if (
    //   selectedFilter === "Fugitive EmissionSource" &&
    //   (selectedFields.fugitiveEmissionSource?.length || 0) === 0
    // ) {
    //   newErrors["Fugitive EmissionSource"] =
    //     "Please select atleast one Fugitive EmissionSource";
    //   isValid = false;
    // }

    // if (
    //   selectedFilter === "Type Of Substance" &&
    //   selectedFields.typeOfSubstance.length === 0
    // ) {
    //   newErrors["Type Of Substance"] =
    //     "Please select atleast one Type Of Substance";
    //   isValid = false;
    // }

    if (selectedFilter === "Quantity Released") {
      const min = parseFloat(tempFilter?.quantityRelsed.min);
      const max = parseFloat(tempFilter?.quantityRelsed.max);

      if (!min && !max) {
        newErrors["Quantity Released"] =
          "Please provide both min and max values";
        isValid = false;
      }

      if (min && isNaN(min)) {
        newErrors["Quantity Released"] =
          "Min consumption must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Quantity Released"] =
          "Max consumption must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Quantity Released"] =
          "Min consumption cannot be greater than max consumption";
        isValid = false;
      }
    }
    if (selectedFilter === "Hours Used") {
      const min = parseFloat(hoursRange.min);
      const max = parseFloat(hoursRange.max);

      if (!min && !max) {
        newErrors["Hours Used"] = "Please provide both min and max values";
        isValid = false;
      }

      if (min && isNaN(min)) {
        newErrors["Hours Used"] = "Min hours must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Hours Used"] = "Max hours must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Hours Used"] =
          "Min hours cannot be greater than max consumption";
        isValid = false;
      }
    }

    console.log("selectedFields1", isValid);
    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    if (!validateFilters()) return;
    setPage(1);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setSelectedFields({
      typeOfSubstance: tempFilter?.typeOfSubstance || [],
    });
    setQuantityRange({
      min: tempFilter?.quantityRelsed.min || "",
      max: tempFilter?.quantityRelsed.max || "",
    });
    setStartMonth(tempFilter?.startMonth);
    setEndMonth(tempFilter?.endMonth);
    fetchData(filtersToApply);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    // Reset local state for date selection and selected fields
    setTempFilter({
      startDate: null,
      endDate: null,
      startMonth: null,
      endMonth: null,
      typeOfSubstance: [],
      quantityRelsed: { min: "", max: "" },
    });
    setStartDate(null);
    setEndDate(null);
    setStartMonth(null);
    setEndMonth(null);
    setSelectedFields({
      typeOfSubstance: [],
    });
    setQuantityRange({
      min: "",
      max: "",
    });

    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate;
    const isMonthApplied = tempFilter?.startMonth || tempFilter?.endMonth;
    const isFugiiveApplied = tempFilter?.fugitiveEmissionSource?.length > 0;
    const isTypeSubstanceApplied = tempFilter?.typeOfSubstance?.length > 0;
    const isQuantityReleasedApplied =
      tempFilter?.quantityRelsed.min && tempFilter?.quantityRelsed.max;

    setIsFiltersApplied(
      isDateApplied ||
        isMonthApplied ||
        isFugiiveApplied ||
        isTypeSubstanceApplied ||
        isQuantityReleasedApplied ||
        isFugiiveApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      //   "Fugitive EmissionSource": isFugiiveApplied,
      "Type Of Substance": isTypeSubstanceApplied,
      "Consumption Month": isMonthApplied,
      "Quantity Released": isQuantityReleasedApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  // useEffect(() => {
  //   fetchCardData();
  // }, [selectedMonth, selectedYear]);

  const handleFilterChangeCards = (cardTitle, filterValue, type) => {
    console.log(cardTitle, filterValue, type, "databasedOfValue");

    if (type === "date") {
      const [year, month] = filterValue.split("-");
      setFilters((prev) => ({
        ...prev,
        month,
        year,
      }));
      console.log(cardTitle, month, year, type, "databased");
      fetchCardData(year, month, "");
    } else if (type === "option") {
      setFilters((prev) => ({
        ...prev,
        [cardTitle]: filterValue,
      }));
      fetchCardData("", "", filterValue);
    } else {
      setFilters((prev) => ({
        ...prev,
        [cardTitle]: filterValue,
      }));
    }
  };

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      typeOfSubstance: selectedFields.typeOfSubstance,
      quantityRelsed: quantityRelsed,
    });
    setDrawerFilterOpen(false);
  };

  const handlePeriodChange = (event) => {
    setSelectedPeriod(event.target.value);
  };

  const columnHeadings = [
    { title: "Date", fieldName: "createdAt" },
    { title: "Consumption Month", fieldName: "consumptionPeriod" },
    // { fieldName: "fugitiveEmissionSource", title: "Emission Source" },
    { fieldName: "typeOfSubstance", title: "Type of Substance" },
    { fieldName: "quantityReleased", title: "Quantity Released" },
    // { fieldName: "quantityOfFuelConsumed", title: "Quantitye of Fuel" },
  ];

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
          />
        );
      case "Consumption Month":
        return (
          <MonthYearFilter
            startMonth={tempFilter?.startMonth}
            endMonth={tempFilter?.endMonth}
            setStartMonth={(month) =>
              setTempFilter((prev) => ({ ...prev, startMonth: month }))
            }
            setEndMonth={(month) => {
              setTempFilter((prev) => ({ ...prev, endMonth: month }));
            }}
            setErrors={setErrors}
            errors={errors.Month}
          />
        );
      case "Type Of Substance":
        return (
          <MultiSelect
            title="Type Of Substance"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  typeOfSubstance: newValue.typeOfSubstance || newValue,
                };
              });
            }}
            errors={errors["Type Of Substance"]}
            setErrors={setErrors}
            field="typeOfSubstance"
            data={uniqueValues.typeOfSubstance}
          />
        );

      //   case "Fugitive EmissionSource":
      //     return (
      //       <MultiSelect
      //         title="Fugitive EmissionSource"
      //         selectedField={selectedFields.fugitiveEmissionSource}
      //         selectedFields={selectedFields}
      //         setSelectedFields={setSelectedFields}
      //         errors={errors["Fugitive EmissionSource"]}
      //         setErrors={setErrors}
      //         field="fugitiveEmissionSource"
      //         data={uniqueValues.fugitiveEmissionSource}
      //       />
      //     );
      case "Fuel Type":
        return (
          <MultiSelect
            title="Fuel Type"
            selectedField={selectedFields.fuelType}
            selectedFields={selectedFields}
            setSelectedFields={setSelectedFields}
            errors={errors["Fuel Type"]}
            setErrors={setErrors}
            field="fuelType"
            data={uniqueValues.fuelType}
          />
        );
      case "Quantity Released":
        return (
          <Range
            title="Quantity Released"
            selectedRange={tempFilter?.quantityRelsed}
            setSelectedRange={(data) => {
              setTempFilter((prev) => ({
                ...prev,
                quantityRelsed: data,
              }));
            }}
            errors={errors["Quantity Released"]}
            setErrors={setErrors}
            placeholderMin={"Min"}
            placeholderMax={"Max"}
          />
        );
      case "Hours Used":
        return (
          <Range
            title="Hours Used"
            selectedRange={hoursRange}
            setSelectedRange={setHoursRange}
            errors={errors["Hours Used"]}
            setErrors={setErrors}
            placeholderMin={"Min(hours)"}
            placeholderMax={"Max(hours)"}
          />
        );
      default:
        return null;
    }
  };

  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };

  const onConfirm = async () => {
    try {
      setBulkUploadTable(false);
      fetchData();
    } catch (error) {
      console.log(error, "error");
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#ededed",
      }}
    >
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {/*Message popup for success or failure */}
      {/* View log, Edit, delete menus */}
      <AddFireExtingulsher
        id={element ? element._id : ""}
        addData={addData}
        setAddData={setAddData}
        data={element}
        addUrl={`${api}/scope1/fireEmission/addFireExtinguisher`}
        updateUrl={`${api}/scope1/fireEmission/updateFireExtinguisher`}
        // details={vehicle}
        fetchData={fetchData}
        setsnackOpen={setsnackOpen}
        inputData={inputData}
      />
      <ViewFireExtingulsher
        id={element ? element._id : ""}
        data={element}
        viewData={viewData}
        setViewData={setViewData}
        inputData={inputData}
        handleEdit={handleEdit}
        companyAdmin={user?.companyAdmin}
      />
      {/* <Grid item xs={6} sx={{  width: "100%" }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          Fugitive Emissions
        </Typography>
        <Box sx={{ display: "flex", width: "100%", mt: 2, gap: 2 }}>
          {/* Card 1: Total Natural Gas Consumed */}
      {/* <SelectCard
            title="Total Quantitty Released"
            content="400kg"
            handleChange={handlePeriodChange}
            value={"Company Owned"}
            list={["Company Owned"]}
          />

          <SelectCard
            title="Fugitive Released"
            content="700 kg"
            handleChange={handlePeriodChange}
            value={selectedPeriod}
            list={months}
          /> */}
      {/* Card 3: Consumption Period */}
      {/* </Box>
      </Grid>  */}
      <Cards
        data={bannerData}
        title="Fugitive Emissions"
        onFilterChange={handleFilterChangeCards}
        {...{ setSelectedMonth, setSelectedYear, selectedMonth, selectedYear }}
      />
      {deleteDialog && (
        <DeleteAlertDialog
          // {...{ deleteDialog, setDeleteDialog, handleDeleteAggree }}
          {...{
            deleteDialog,
            setDeleteDialog,
            id: element._id,
            url: `${api}/scope1/fireEmission/deleteFireExtinguisher`,
            setsnackOpen,
            fetchData,
            fetchCardData,
          }}
        />
      )}
      {/* Filter Drawer */}
      {drawerFilterOpen && (
        <FilterDrawer
          {...{
            renderSelectedFilter,
            drawerFilterOpen,
            setDrawerFilterOpen,
            handleApplyFilters,
            handleFilterDrawer,
            setSelectedFilter,
            handleResetFilters,
            selectedFilter,
            filters,
            appliedFilters,
            selectedFields,
            setSelectedFields,
          }}
        />
      )}{" "}
      {/* Top Box for Heading, Filter Button, Add Data Button */}
      <TopMenuUpload
        setData={setElement}
        setAddData={setAddData}
        {...{
          // heading: "Coal",
          setBulkUploadModal,
          setDrawerFilterOpen,
          filterApplied: isFiltersApplied,
        }}
      />
      <TableContainer
        component={Paper}
        sx={{
          maxWidth: "100%",
          marginBottom: "1rem",
        }}
      >
        <Box>
          <TableHeading heading={"Fire Extinguishers"} />
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "12% 21% 36% 22% 8%",
              borderBottom: "1px solid #ddd",
              borderTop: "1px solid #ddd",
            }}
          >
            {columnHeadings.map((el) => (
              <ColumnHeadings
                key={el}
                {...{
                  title: el.title,
                  key: el.title,
                  handleSort,
                  field:
                    el.fieldName === "quantityReleased"
                      ? "quantityReleased.value"
                      : el.fieldName,
                  sortConfig,
                }}
              />
            ))}
            <Typography
              sx={{
                fontWeight: "bold",
                padding: "8px 12px",
                textAlign: "center",
              }}
            >
              Action
            </Typography>
          </Box>
          {data && data.length > 0 ? (
            data.map((item) => (
              <Box
                key={item._id}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "12% 21% 36% 22% 8%",
                  borderBottom: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) => (
                  <TableContent
                    key={el.fieldName}
                    {...{
                      fieldData:
                        el.fieldName === "consumptionPeriod"
                          ? getMonthName(item[el.fieldName]?.month) +
                            " " +
                            item[el.fieldName]?.year
                          : typeof [el.fieldName] === "object" &&
                            // [el.fieldName] !== null &&
                            [el.fieldName].value
                          ? [el.fieldName]?.value
                          : typeof item[el.fieldName] === "object" &&
                            item[el.fieldName] !== null &&
                            item[el.fieldName].value
                          ? truncateNumber(item[el.fieldName]?.value)
                          : item[el.fieldName],
                      dateField: el.fieldName === "createdAt" ? item.createdAt : false,
                    }}
                  />
                ))}
                <MenuIcon {...{ handleMenuClick, field: item }} />
              </Box>
            ))
          ) : (
            <NoDataFound />
          )}
        </Box>
      </TableContainer>
      {/* Pagination */}
      {totalPages > 1 && (
        <PaginationBox
          {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
        />
      )}
      <MenuActions
        {...{
          id: element?._id,
          handleView,
          handleEdit,
          handleDelete,
          anchorEl,
          handleMenuClose,
        }}
      />
      {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={handleCloseBulkUpload}
          isBulkUploadModal={bulkUploadModal}
          {...{
            setsnackOpen,
            excelData,
            setMatchData,
            formDataBulkUpload,
            setFormDataBulkUpload,
          }}
          errorClose={uploadErrorClose}
          matchedKey="statusList"
          setBulkUploadModal={setBulkUploadModal}
          fileName={"Fire Extinguisher"}
          url={"/scope1/fireEmission/fireExtinguisher/bulkupload"}
        />
      )}
      {bulkUploadTable && (
        <FugitiveBulkUpload
          matchData={matchData}
          setMatchData={setMatchData}
          onClose={() => setBulkUploadTable(false)}
          bulkUploadTable={bulkUploadTable}
          {...{ formDataBulkUpload, setFormDataBulkUpload }}
          addNew={false}
          title1="Type Of Substance"
          keyValue1="typeOfSubstance"
          options1={typeOfSubstanceList}
          matched1="matchedEmissionFactor"
          onConfirm={onConfirm}
          jsonBulkUpload={formDataBulkUpload}
          bulkUploadUrl="/scope1/fireEmission/fireExtinguisher/jsonupload"
          setsnackOpen={setsnackOpen}
          fieldName="Type Of Substance"
        />
      )}
      {/*Add,Edit,Delete Icons & function calls */}
    </Box>
  );
};

export default FireExtingulsher;
